@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-empty-case-default/lib/index';
@import '~@adv-mt/mt-hero-dealers-list/lib/index';
@import '~@adv-mt/mt-list-dealers/lib/index';
@import '~@adv-mt/mt-list-pagination/lib/index';
@import '~@adv-mt/mt-list-provinces/lib/index';
@import '~@adv-mt/mt-section-basic/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-list-tagcloud/lib/index';
@import '~@adv-mt/mt-list-makes/lib/index';

$maw-empty-case: 500px;
$h-dealer-list-results: 40px;

.mt-DealersList {
  margin-top: $m-xl;
  padding: $p-m;

  @include media-breakpoint-up(s) {
    padding: 0;
  }

  &-results {
    background-color: $c-white;
    border-radius: $bdrs-m;
    box-shadow: $bxsh-m;
    display: flex;
    margin-bottom: $m-m;
    height: $h-dealer-list-results;
    padding: 0 $p-l;

    @include media-breakpoint-up(s) {
      background-color: inherit;
      box-shadow: none;
      padding: 0;
    }
  }

  &-empty {
    max-width: $maw-empty-case;
    margin: 0 auto;
  }
}
